import { createActions } from "../../helpers/actionsHelper";
import { CustomerActionTypes, attachPaymentMethodActionType } from "../../model/customer/actions";

export const attachPaymentMethod = createActions<CustomerActionTypes, string, null>(attachPaymentMethodActionType);
